import { useWebSocket } from '../../hooks/useWebSocket';
import { LiveMonitorEventStream } from './LiveMonitorEventStream';
import { LiveMonitorPositions } from './LiveMonitorPositions';
import { LiveMonitorActionPanel } from './LiveMonitorActionPanel';
// 화면 5 는 화면 8 의 severity 배지 / 모달 backdrop / ghost 버튼 등 syslog-* 공통
// 스타일을 재사용하므로 함께 로드.
import '../SystemLog/systemLog.css';
import './liveMonitor.css';

// 권위: docs/ARCH_DASHBOARD.md §4.5 화면 5 Live Monitor (시스템 총괄).
// 3-패널 레이아웃:
//   ┌─────────────┬────────────────┬────────────┐
//   │ 좌: 이벤트    │ 중: PnL 요약     │ 우: 제어/알림 │
//   │    스트림    │ (간략, 상세는    │  + 수동 CB   │
//   │              │  /positions 링크) │              │
//   └─────────────┴────────────────┴────────────┘
//
// 책임 분리 (UNIMPLEMENTED_INVENTORY §4):
//   - /live           : 시스템 총괄 — 본 화면
//   - /trading/live   : 트레이딩 깊이 (시그널 flow / Slot trigger)
//   - /positions      : 포지션 상세
//
// 연결 끊김 배너는 AppShell 에서 이미 상단에 렌더되고 있으므로, 본 페이지는 해당 상태에 따라
// 섹션 내부에도 명시적 배너를 추가 노출한다 (화면 5 특성상 중요).

export default function LiveMonitorPage(): JSX.Element {
  const { status } = useWebSocket();
  const disconnected = status !== 'connected';

  return (
    <div className="live-monitor">
      <header className="live-monitor__header">
        <h1 className="live-monitor__title">실시간 현황 (시스템 총괄)</h1>
        <span
          className={`live-monitor__status live-monitor__status--${status}`}
          aria-live="polite"
        >
          {statusLabel(status)}
        </span>
      </header>

      {disconnected && (
        <div className="live-monitor__offline-banner" role="status">
          실시간 연결이 끊겼습니다. 수신된 이벤트가 누락될 수 있습니다. 자동 재연결 중…
        </div>
      )}

      <div className="live-monitor__grid">
        <div className="live-monitor__col live-monitor__col--left">
          <LiveMonitorEventStream />
        </div>
        <div className="live-monitor__col live-monitor__col--center">
          <LiveMonitorPositions />
        </div>
        <div className="live-monitor__col live-monitor__col--right">
          <LiveMonitorActionPanel />
        </div>
      </div>
    </div>
  );
}

function statusLabel(status: string): string {
  switch (status) {
    case 'connected':
      return '● LIVE';
    case 'connecting':
      return '연결 중…';
    case 'reconnecting':
      return '재연결 중…';
    default:
      return '오프라인';
  }
}
